import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import config from "../config";
import AdminShell, { dt } from "./AdminShell";

const API = config.API_BASE_URL;

function StatusCard({ title, ok, children }) {
  return (
    <div className="ad-card">
      <h3>
        {title} <span className={`ad-chip ${ok ? "ok" : "fail"}`}>{ok ? "OK" : "ΠΡΟΒΛΗΜΑ"}</span>
      </h3>
      <div className="ad-hint" style={{ lineHeight: 1.7 }}>{children}</div>
    </div>
  );
}

export default function AdminSystem() {
  const { t } = useTranslation();
  const [s, setS] = useState(null);

  const load = useCallback(() => {
    axios.get(`${API}/admin/system`).then((r) => setS(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    load();
    const iv = setInterval(load, 30000);
    return () => clearInterval(iv);
  }, [load]);

  if (!s) return <AdminShell><div className="ad-empty">…</div></AdminShell>;

  const backupOk =
    s.backup?.available &&
    ((s.backup?.["15m"]?.ageMinutes != null && s.backup["15m"].ageMinutes < 60) ||
      /OK/.test(s.backup?.statusText || ""));
  const mailFailed = s.mail?.last24h?.failed || 0;

  return (
    <AdminShell>
      <div className="ad-hint" style={{ marginBottom: 10 }}>
        {t("Last check")}: {dt(s.checkedAt)} · {t("auto-refresh every 30s")}
      </div>
      <div className="ad-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))" }}>
        <StatusCard title="MySQL" ok={!!s.db?.ok}>
          {s.db?.ok ? <>v{s.db.version} · {s.db.latencyMs}ms</> : s.db?.error}
        </StatusCard>
        <StatusCard title="Redis" ok={!!s.redis?.ok}>
          {s.redis?.ok ? <>{s.redis.latencyMs}ms</> : s.redis?.error}
        </StatusCard>
        <StatusCard title={t("Email queue")} ok={!!s.mail?.ok && !mailFailed}>
          {s.mail?.ok ? (
            <>
              {t("Queued now")}: {s.mail.queuedNow} · 24h: {t("sent")} {s.mail.last24h?.sent || 0}, {t("failed")} {mailFailed}
            </>
          ) : s.mail?.error}
        </StatusCard>
        <StatusCard title={t("Backups")} ok={!!backupOk}>
          {s.backup?.available ? (
            <>
              {s.backup.statusText && (
                <div style={{ whiteSpace: "pre-line", marginBottom: 4 }}>{s.backup.statusText}</div>
              )}
              {s.backup["15m"] && (
                <>15m: {s.backup["15m"].lastFile} · {t("Age")}: {s.backup["15m"].ageMinutes} {t("minutes")}<br /></>
              )}
              {s.backup.daily && (
                <>daily: {s.backup.daily.lastFile} · {t("Age")}: {Math.round(s.backup.daily.ageMinutes / 60)}h</>
              )}
              {!s.backup.statusText && !s.backup["15m"] && !s.backup.daily && t("No backup files found.")}
            </>
          ) : (
            t("Backup folder not accessible from the API container.")
          )}
        </StatusCard>
        <StatusCard title="API" ok>
          Node {s.api.node} · RSS {s.api.rssMb}MB · uptime {Math.floor(s.api.uptimeSec / 3600)}h{" "}
          {Math.floor((s.api.uptimeSec % 3600) / 60)}m
        </StatusCard>
        <div className="ad-card">
          <h3>{t("Scheduled jobs")}</h3>
          <div className="ad-hint" style={{ lineHeight: 1.8 }}>
            {s.jobs.map((j) => (
              <div key={j.name}>{j.name} — {j.schedule}</div>
            ))}
          </div>
        </div>
        <div className="ad-card">
          <h3>{t("Admin audit (7d)")}</h3>
          <div className="ad-hint" style={{ lineHeight: 1.8 }}>
            {s.audit7d && Object.keys(s.audit7d).length ? (
              Object.entries(s.audit7d).map(([a, c]) => <div key={a}>{a}: {c}</div>)
            ) : (
              "—"
            )}
          </div>
        </div>
      </div>
    </AdminShell>
  );
}
